"use client";

import SectionHeader from "./SectionHeader";
import clsx from "clsx";

/**
 * LayoutWrapper
 * Section seviyesinde ortak görünüm sarmalayıcısı.
 * - section.settings.section üzerinden özelleştirilebilir
 * - layout: false ile tamamen devre dışı bırakılabilir
 * - Class ayarları:
 *   - sectionClass: <section> elementine ekstra class'lar
 *   - containerClass: <div className="container"> elementine ekstra class'lar
 *   - innerContainerClass: <div className="inner-container"> elementine ekstra class'lar
 * - header ayarları: showHeader, align, className
 * - spacing ayarları: header (header ile content arası), content (content'e ekstra spacing)
 */
export default function LayoutWrapper({
  title,
  description,
  link,
  settings,
  children,
}) {
  const sectionSettings = settings?.section || {};
  const layoutEnabled = sectionSettings.layout !== false;

  // Her seviye için ayrı class ayarları
  const sectionClass = sectionSettings.sectionClass || "";
  const containerClass = sectionSettings.containerClass || "";
  const innerContainerClass = sectionSettings.innerContainerClass || "";

  const headerSettings = sectionSettings.header || {};
  const showHeader = headerSettings.showHeader !== false; // varsayılan: göster
  const headerAlign = headerSettings.align || "left";
  const headerClassName = headerSettings.className || "";
  const headerTitleAs = headerSettings.titleAs || "h2";

  // Spacing ayarları - header ile content arasındaki boşluk
  const spacingSettings = sectionSettings.spacing || {};
  const headerSpacing = spacingSettings.header || "mb-4 lg:mb-6"; // default: mobile 16px, desktop 32px
  const contentSpacing = spacingSettings.content || "";

  if (!layoutEnabled) {
    return children;
  }

  return (
    <section className={clsx("section w-full", sectionClass)}>
      <div className={clsx("container mx-auto", containerClass)}>
        <div className={clsx("inner-container relative", innerContainerClass)}>
          {showHeader &&
            (title || description || (link && link.href && link.text)) && (
              <SectionHeader
                title={title}
                description={description}
                align={headerAlign}
                titleAs={headerTitleAs}
                linkText={link?.text}
                href={link?.href}
                preserveTrailingSlash={link?.preserveTrailingSlash}
                className={clsx(headerClassName, headerSpacing)}
              />
            )}
          <div className={contentSpacing}>{children}</div>
        </div>
      </div>
    </section>
  );
}
